import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root',
})
export class EstadoMaquinaService {
  constructor(private gqlclient: GraphQLClient) {}

  obtenerTodos(callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          {
            estado_maquina {
              obtenerTodos {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    nombre
                    codigo
                    descripcion
                  }
                }
              }
            }
          }
        `,
        variables: {},
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.estado_maquina.obtenerTodos;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerEstadosNoInactivo(callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          {
            estado_maquina {
              obtenerSegunFiltro {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    nombre
                    codigo
                    descripcion
                  }
                }
              }
            }
          }
        `,
        variables: {},
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.estado_maquina.obtenerSegunFiltro;
        callback({ mensajes, respuesta });
      }
    );
  }
}
